import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from '../../service/validation/login';
import AuthContainer from '../../containers/Auth';
import AuthInputText from '../../components/AuthInput';
import { useNavigate } from 'react-router-dom';
import { TokenContext } from '../../service/context/tokencontent';
import CAPTCHA from '../../service/captcha';
import { ApiService } from '../../service/api.service';
import { AUTH_URL } from '../../common/common';

const Login = () => {
  const { setToken } = useContext(TokenContext)!;
  const apiService = new ApiService();
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState<string>("");
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      emailId: '',
      password: '',
    },
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });
  const emailValue = watch("emailId", "");
  const onSubmit = async (data: any) => {

    try {
      const mobileRegex = /^[6-9]\d{9}$/;

      const payload: any = {
        password: data.password,
      };

      // Determine whether the input is email or mobile number
      if (mobileRegex.test(data.emailId)) {
        payload.mobileNumber = data.emailId;
      } else {
        payload.emailId = data.emailId;
      }
      let response: any = await apiService.postApi(`${AUTH_URL}/login-route`, payload);

      if (response.status === "200") {
        const tokenValue = response.body.authToken;
        localStorage.setItem("user_data_motsop", JSON.stringify(response.body.data));
        if (response.body.data.isactive) {
          let { entityid, userId } = response.body.data;
          localStorage.setItem("entity_id", entityid);
          localStorage.setItem("motosop", tokenValue);
          localStorage.setItem("userId", userId);
          setToken(tokenValue);
          navigate('/dashboard');
        } else {
          let { entityid, userId } = response.body.data;
          localStorage.setItem("entity_id", entityid);
          localStorage.setItem("userId", userId);
          navigate('/businesstype');
        }
      } else {
        console.error("Invalid login credentials.");
      }
    } catch (error) {
      console.error('Login Error:', error);
    }
  };
  useEffect(() => {
    const mobileRegex = /^[6-9]\d{9}$/;
    if (mobileRegex.test(emailValue)) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [emailValue]);


  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        <div className="w-full h-full">
          <div className="mx-[4rem] my-[2rem] m-6">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">logo</div>
            <br />
            <p className="font-[700] text-[20px] font-poppins track-[1%]">Welcome Back 👋</p>
            <p className="font-[400] text-[16px] text-[#313957]">Sign into Smart Fleet Management system</p>
            <br />

            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <AuthInputText
                label="Email or Mobile Number"
                value={watch('emailId', '')}
                errors={errors}
                type={isMobile ? "number" : "text"}
                placeholder="Enter Email or Mobile Number"
                autoComplete="emailId"
                name="emailId"
                maxLength={isMobile ? 10 : 30}
                register={register}
              />
              <AuthInputText
                label="Password"
                value={watch('password', '')}
                errors={errors}
                placeholder="Enter your password"
                autoComplete="password"
                name="password"
                type="password"
                register={register}
              />
              <button type='button' onClick={() => navigate('/forgotpassword')} className='text-right float-right text-[14px] text-[#1E4AE9]'>
                Forgot Password?
              </button>

              {/* CAPTCHA */}
              <div className='flex items-center w-full justify-center '>
                {/* <CAPTCHA onVerify={setCaptchaToken} /> */}
              </div>

              {/* Submit button (disabled until CAPTCHA is completed) */}

              <div className='mx-6'>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  // disabled={isSubmitting || !captchaToken}
                  className={`mt-4 p-2 w-full h-[50px] text-[16px] bg-[#444FBD] rounded-[20px] text-white ${(isSubmitting) ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  {isSubmitting ? 'Submitting...' : 'Sign in'}
                </button>
              </div>

              <div className='flex justify-center items-center gap-2 mt-4'>
                <div className='h-[1px] w-[40%] bg-[#000000]' />
                <div className='text-[16px]'>or</div>
                <div className='h-[1px] w-[40%] bg-[#000000]' />
              </div>

              <p className='text-center mt-2 text-[16px]'>Don't have an account? <span className='text-[#444FBD] font-[600] cursor-pointer' onClick={() => navigate('/signup')}>Sign up now</span></p>
              <p className="text-[12px] font-[500] mt-2 text-center items-center">
                <input type='checkbox' checked className='mr-1' />By signing in, you agree to our{" "}
                <a href="/terms" className="text-[#444FBD] hover:underline">T&C</a>,{" "}
                <a href="/privacy" className="text-[#444FBD] hover:underline">Privacy Policy</a>,
                <a href="/cancellation&refund" className="text-[#444FBD] hover:underline"> Cancellation & Refund Policy</a> and <a href="/shipping&delivery" className="text-[#444FBD] hover:underline">Shipping & Delivery Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default Login;
